<div class="practice-plan-row" [formGroup]="rowForm" [class.row-error]="hasError">
  <div class="row align-items-end">
    <div class="col-md-2 form-group">
      <label class="small">{{ 'practicePlan.row.start' | translate }} <span class="text-danger">*</span></label>
      <timepicker class="timepicker" formControlName="start" [hourStep]="1" [minuteStep]="5"
        [showMeridian]="false" [mousewheel]="false" [showSpinners]="false"></timepicker>
      @if (rowForm.get('start')?.invalid && submitted) {
        <div class="invalid-tooltip d-block">{{ 'practicePlan.row.startRequired' | translate }}</div>
      }
    </div>
    <div class="col-md-2 form-group">
      <label class="small">{{ 'practicePlan.row.end' | translate }} <span class="text-danger">*</span></label>
      <timepicker class="timepicker" formControlName="end" [hourStep]="1" [minuteStep]="5"
        [showMeridian]="false" [mousewheel]="false" [showSpinners]="false"></timepicker>
      @if (rowForm.get('end')?.invalid && submitted) {
        <div class="invalid-tooltip d-block">{{ 'practicePlan.row.endRequired' | translate }}</div>
      }
      @if (rowForm.errors?.dateMoreThan && submitted) {
        <div class="invalid-tooltip d-block">{{ 'practicePlan.row.endAfterStart' | translate }}</div>
      }
    </div>
    <div class="col-md-3 form-group">
      <label class="small">{{ 'practicePlan.row.configuration' | translate }} <span class="text-danger">*</span></label>
      <button type="button" class="btn btn-link btn-sm p-0 ml-1" [class.text-muted]="!showPreview"
        [title]="(showPreview ? 'setupPreview.hide' : 'setupPreview.show') | translate" [attr.aria-pressed]="showPreview" (click)="showPreview = !showPreview">
        <i class="simple-icon-eye"></i>
      </button>
      <ng-select appearance="outline" [items]="recordingSetups" [searchable]="true"
        [loading]="recordingSetupsLoading" bindValue="v" bindLabel="d" [compareWith]="compareSetupRefs" formControlName="recordingSetup">
      </ng-select>
      @if (rowForm.get('recordingSetup')?.errors?.required && submitted) {
        <div class="invalid-tooltip d-block">{{ 'practicePlan.row.configurationRequired' | translate }}</div>
      }
    </div>
    <div class="col-md-3 form-group">
      <label class="small">{{ 'practicePlan.row.eventName' | translate }} <span class="text-danger">*</span></label>
      <input class="form-control form-control-sm" formControlName="eventName" />
      @if (rowForm.get('eventName')?.errors?.required && submitted) {
        <div class="invalid-tooltip d-block">{{ 'practicePlan.row.eventNameRequired' | translate }}</div>
      }
    </div>
    <div class="col-md-2 form-group">
      <label class="small">{{ 'practicePlan.row.buffersLabel' | translate }}</label>
      <div class="d-flex align-items-center">
        <input type="number" min="0" class="form-control form-control-sm buffer-input"
          formControlName="bufferBefore" />
        <span class="mx-1">/</span>
        <input type="number" min="0" class="form-control form-control-sm buffer-input"
          formControlName="bufferAfter" />
        <button type="button" class="btn btn-link btn-sm p-0 ml-1"
          [title]="'practicePlan.row.resetToDefault' | translate" (click)="resetBuffers()">
          <i class="simple-icon-refresh"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <small class="text-muted">
        @if (rowForm.get('category')?.value) {
          <span class="badge badge-secondary mr-1">{{ rowForm.get('category')?.value }}</span>
        }
        @if (rowForm.get('detail')?.value) {
          <span>{{ rowForm.get('detail')?.value }}</span>
        }
      </small>
      @if (showPreview) {
        <app-recording-setup-preview class="mt-2" [setupPath]="rowForm.get('recordingSetup')?.value?.path" [maxHeight]="130"></app-recording-setup-preview>
      }
      @if (hasError) {
        <div class="invalid-tooltip d-block">{{ rowForm.get('errorMessage')?.value }}</div>
      }
    </div>
  </div>
</div>
